// extracted by mini-css-extract-plugin
export default {"container":"EMO7ar","gradient":"cpvra1","header":"HdaaoT","background":"Qcg8u8"};